<template>
  <div>
    <HeadingExtraSmall>
      {{ title }}
    </HeadingExtraSmall>
    <GuideMessage
      v-if="showGuideMessage"
      caretPosition="left"
      :class="$style.assignmentGuideMessage"
      name="userAssignment"
    />
    <SegmentedButton
      v-if="tabButtonOptions"
      :class="$style.segmentedButtons"
      name="includedUsers"
      :options="tabButtonOptions"
      :showValidationMessage="false"
      :value="tabButtonValue"
      @input="handleSegmentedButtonInput"
    />
    <div
      v-if="!hideSearch"
      :class="$style.fieldGroup"
    >
      <UserGroupsSearch
        :previousValue="previousIncludedGroups"
        :validationConfig="validationConfig"
        :value="searchValue"
        @input="handleGroupsChange"
      />
    </div>

    <NotificationInPage
      v-if="showNotification"
      :class="$style.notification"
      :notification="notificationConfig"
    >
      <template v-slot:message>
        <strong>{{ appInfoMessage }} </strong>
        <Link
          :href="knowledgeBaseDetails.url"
          isExternal
          target="_blank"
          :text="knowledgeBaseDetails.text"
        />
      </template>
    </NotificationInPage>
  </div>
</template>

<script>
import {
  HeadingExtraSmall,
  Link,
  NotificationInPage,
  SegmentedButton,
  Types,
} from '@jumpcloud/ui-components';

import GuideMessage from 'client/components/GuideMessage/GuideMessage.vue';
import UserGroupsSearch from 'client/Security/AuthNPoliciesAsidePanel/UserGroupsSearch.vue';

const { NotificationConfig } = Types;

export default {
  name: 'UserGroupSelection',

  components: {
    GuideMessage,
    HeadingExtraSmall,
    Link,
    NotificationInPage,
    SegmentedButton,
    UserGroupsSearch,
  },

  props: {
    appInfoMessage: {
      type: String,
      default: '',
    },
    hideSearch: Boolean,
    knowledgeBaseDetails: {
      type: Object,
      default: () => {},
    },
    previousIncludedGroups: {
      type: Array,
      default: () => {},
    },
    searchValue: {
      type: Array,
      default: () => {},
    },
    showGuideMessage: Boolean,
    showNotification: Boolean,
    tabButtonOptions: {
      type: Array,
      default: () => {},
    },
    tabButtonValue: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    validationConfig: {
      type: Object,
      default: () => ({
        name: '',
        rules: '',
        disabled: false,
      }),
    },
  },

  computed: {
    notificationConfig() {
      return NotificationConfig({
        icon: 'info',
        type: 'informational',
      });
    },
  },

  methods: {
    handleGroupsChange(value) {
      this.$emit('handleGroupsChange', value);
    },

    handleSegmentedButtonInput(value) {
      this.$emit('handleCategoryChange', value);
    },
  },
};
</script>

<style module>
  .segmentedButtons,
  .fieldGroup {
    margin-top: var(--jc-spacer);
  }

  .notification {
    margin: var(--jc-spacer) 0;
  }

  .assignmentGuideMessage div {
    left: 420px;
    top: -72px;
  }
</style>
